import React from 'react';
import Navbar from '../global-components/navbar';
import Footer_v2 from '../global-components/footer-v2';
import Page_header from '../global-components/page-header';

const ThankYou = () => {
    return <div>
        <Navbar />
        <Page_header headertitle="Thank You"  />
        <center>
            <br/>
            <br/>
            <h4>We will get back to you shortly</h4>
            <br/>
            <br/>

        </center>
        <Footer_v2 />
    </div>
}

export default ThankYou

